module.exports = __webpack_public_path__ + "static/media/favoritos.b3262e51.svg";